module.exports = __webpack_public_path__ + "static/media/arsyad-1.93a150cb.jpg";